import type { FC, HTMLProps, ReactNode } from "react";

import type { Size } from "@shared/types/sizes";

import * as styles from "./ContentWrapper.styles";

interface Props extends HTMLProps<HTMLDivElement> {
  isDark?: boolean;
  type?: Size;
  children: ReactNode;
}

const ContentWrapper: FC<Props> = ({ children, isDark, type, ...rest }) => {
  const contentWrapperStyles = [
    styles.contentWrapper.base,
    type && styles.contentWrapper[type],
    isDark && styles.contentWrapper.darkBackground,
  ];

  return (
    <div css={contentWrapperStyles} {...rest}>
      {children}
    </div>
  );
};

export { ContentWrapper };
